import React from 'react';
import enhance from './enhance';
import styles from './styles.module.scss';

export const Charm = ({ charm, charmStyle, icon, iconAlt, detail }) => (
  <span className={charmStyle}>
    <img alt={iconAlt} src={icon} />
    {detail && <span className={styles.charmDescription}>{charm.id}</span>}
  </span>
);

export default enhance(Charm);
